export default __webpack_public_path__ + "static/media/bernygroup1b.8b505830.jpg";